// CHANGE v2 §12: CTA do fluxo guiado G1 aponta para /expenses/new — esta rota
// abre o QuickExpenseSheet global e redirecciona para a lista de despesas.
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../routes/paths';

import { useExpenseSheet } from '../../features/expenses/SheetProvider';

export function ExpensesQuickOpen() {
  const navigate = useNavigate();
  const { open } = useExpenseSheet();

  useLayoutEffect(() => {
    open();
    navigate(paths.expenses, { replace: true });
  }, [open, navigate]);

  return null;
}

export default ExpensesQuickOpen;
